import React from 'react';
import './PageHeader.scss';

export default function PageHeader({ children, title })
{
    return (
        <div className='page-header'>
            <span>{title ? <h3>{title}</h3> : null}</span>
            <span>{children}</span>
        </div>
    )
}